/* MAIN File */
// imports
import './scss/main.scss';
import './js/scripts.js';
